import { modals } from '@mantine/modals';

import { TransitGuarantee } from '@e-origin/shared';

import { EditTransitGuarantee } from './EditTransitGuarantee';
import { EditTransitGuaranteeAccessCodeData } from './EditTransitGuaranteeAccessCodeData';

export const transitGuaranteesModalManager = {
  openEditGuarantee: (guarantee: TransitGuarantee, onSave: (values: TransitGuarantee) => void) => {
    modals.open({
      title: 'Update guarantee data',
      centered: true,
      children: (
        <EditTransitGuarantee
          guarantee={guarantee}
          onSave={(values) => {
            onSave(values);
            modals.closeAll();
          }}
          onClose={modals.closeAll}
        />
      ),
    });
  },
  openEditAccessData: (guarantee: TransitGuarantee, onSave: (values: TransitGuarantee) => void) => {
    modals.open({
      title: 'Update access code data',
      centered: true,
      children: (
        <EditTransitGuaranteeAccessCodeData
          guarantee={guarantee}
          onSave={(values) => {
            onSave(values);
            modals.closeAll();
          }}
          onClose={modals.closeAll}
        />
      ),
    });
  },
};
